<div class="card-comment">
  <div class="card-block-small">
    <a [routerLink]="['/profile', membership.member.username]">
      <img
        *ngIf="membership.member.image"
        class="community-member-image"
        [src]="membership.member.image"
        alt="community-member-image"
      />
      <img
        *ngIf="!membership.member.image"
        class="community-member-image"
        [src]="defaultUserImg"
        alt="community-member-image"
      />
    </a>
    <div class="comment-desc">
      <a [routerLink]="['/profile', membership.member.username]">
        <div class="text-left">
          <h6>{{ membership.member.username }}</h6>
          <p
            *ngIf="membership.member.bio"
            class="text-muted"
            [innerHTML]="membership.member.bio | slice: 0:100"
          ></p>
          <p *ngIf="!membership.member.bio" class="text-muted">No bio</p>
        </div>
      </a>

      <div class="text-left">
        <i class="text-muted">
          Member since, {{ membership.createdAt | date: "longDate":"UTC" }}
        </i>
      </div>
    </div>
  </div>
  <hr />
</div>
